import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/5a3e874b7e3ffc010b332293aafba688.jpg"
          alt="Hero Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center text-white max-w-5xl mx-auto px-6 py-32">
        <p className="text-sm uppercase tracking-widest mb-6 text-white/90">(Welcome to the Ministry)</p>
        <h1 className="text-5xl md:text-7xl font-serif font-bold mb-8 leading-tight">
          Words That Transform Lives
        </h1>
        <p className="text-lg md:text-xl mb-12 max-w-3xl mx-auto leading-relaxed text-white/95">
          Discover biblically-grounded books that inspire faith, deepen your relationship with God, and guide you through every season of life.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-5">
          <a
            href="/books"
            className="bg-[#D4AF37] text-[#1B3A52] px-8 py-3 rounded-full text-base font-medium hover:bg-[#c49d2f] transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            Explore Books
          </a>
          <a
            href="/about"
            className="bg-white/10 backdrop-blur-sm text-white border-2 border-white px-8 py-3 rounded-full text-base font-medium hover:bg-white hover:text-[#1B3A52] transition-all whitespace-nowrap cursor-pointer"
          >
            About Pastor Don
          </a>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 z-10">
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-white/70 rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
